import {useMemo} from "react";
import {useSelector} from "react-redux";

export default () => {

	const {theme} = useSelector(store => store);

	return useMemo(() => {
		return {
			...theme
		};
	}, [theme]);

};
